import { i18nMark } from 'lingui-react';

const messages = {
  title: i18nMark('Asset Summary'),
  maintenance: i18nMark('Maintenance'),
  campaigns: i18nMark('Campaigns'),
  warranty: i18nMark('Warranty'),
  unit: i18nMark('UNIT'),
  vin: i18nMark('VIN'),
  make: i18nMark('Make'),
  model: i18nMark('Model'),
  year: i18nMark('Year'),
  engine: i18nMark('Engine'),
  odometer: i18nMark('Odometer'),
  current: i18nMark('Current'),
  due: i18nMark('Due'),
  overdue: i18nMark('Overdue'),
  allCurrent: i18nMark('All Current'),
  someCurrent: i18nMark('Some Current'),
  noCoverage: i18nMark('No Coverage'),
  campaignDue: i18nMark('Campaign Due'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/AssetSummaryWidget/messages.js